import { Component, Inject, OnInit } from '@angular/core';
import { CallQueueLogin, CallQueueService } from '../services/call-queue.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CallQueueLoginInput } from 'src/generated/eveportal-api/graphql';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-call-queue-dialog',
  templateUrl: './call-queue-dialog.component.html',
  styleUrls: ['./call-queue-dialog.component.css'],
})
export class CallQueueDialogComponent implements OnInit {
  queues: any[] = [];
  eveUserId!: number;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { queues: any[], eveUserId: number },
    private callQueueService: CallQueueService,
    private snack: MatSnackBar
  ) {
    ({ queues: this.queues, eveUserId: this.eveUserId } = data); // Destructure to get queues and eveUserName
  }

  ngOnInit() {}

  onToggle(queue: CallQueueLogin) {
    const newValue = !queue.isLoggedIn; 
    
    const input: CallQueueLoginInput = {
    callQueueId: queue.callQueueId,
    eveUserId: this.eveUserId,   // ✅ provided by parent component
    isloggedIn: newValue
  };

    this.callQueueService
      .updateCallQueueLogin(input)
      .subscribe({
        next: (result: any) => {
           console.log('success to update queue login', result);
        },
        error: (err) => {
          const errorMessage = "Failed to update queue login: " + (err instanceof Error ? err.message : 'Unknown error');
          this.snack.open(errorMessage, 'Dismiss');
        },
      });
  }
}
